import * as Yup from 'yup';

const permissionValidator = Yup.object({
  resource: Yup.string().required(),
  operations: Yup.array()
    .required()
    .of(Yup.string())
    .min(1, 'Selecione ao menos uma operação'),
});

export const createPolicyValidationSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  permissions: Yup.array()
    .required()
    .of(permissionValidator)
    .min(1, 'Insira ao menos uma permissão'),
});
